<template>
  <el-dialog :title="!getAddressModal.id?'新增收货地址':'编辑收货地址'" :visible="true" width="820px" center :before-close="cancelAddress" :destroy-on-close="false" :close-on-click-modal="false">
    <div style="background: #f1f1f1;padding: 10px 0;border-radius: 4px;width:80%;margin:0 auto;">
      <div class="address-border">
        <span class="span-left"><i >*</i>所在地区：</span>
        <div style="display: inline;">
          <el-select v-model="province" @change="getCity()" style="width: 140px" size="small">
            <el-option :value="0" label="请选择" />
            <el-option v-for="(item,i) in provinceList" :value="item.dt_id" :key="i" :label="item.dt_name" />
          </el-select>
          <el-select v-model="city" @change="getArea()" style="width: 140px" size="small">
            <el-option :value="0" label="请选择" />
            <el-option v-for="(item,i) in cityList" :value="item.dt_id" :key="i" :label="item.dt_name" />
          </el-select>
          <el-select v-model="area" style="width: 140px" size="small">
            <el-option :value="0" label="请选择" />
            <el-option v-for="(item,i) in areaList" :value="item.dt_id" :key="i" :label="item.dt_name" />
          </el-select>
        </div>
      </div>
      <div class="address-border">
        <span class="span-left"><i >*</i>详细地址：</span>
        <input v-model="receivingDetailedAddress" type="text" name="" placeholder="为保证顺利收货，请写明详细收货地址">
      </div>
      <div class="address-border">
        <span class="span-left"><i >*</i>收货人姓名：</span>
        <input v-model="consigneeName" type="text" placeholder="长度不超过25个字符" maxlength="25" />
      </div>
      <div class="address-border">
        <span class="span-left"><i >*</i>手机号码：</span>
        <input v-model="telephone" type="text" placeholder="电话号码、手机号码必须填一项" maxlength="11">
      </div>
      <div class="address-border">
        <span class="span-left">座机号：</span>
        <input v-model="phone" type="text" placeholder="座机号">
      </div>
      <div class="address-border">
        <span class="span-left">邮箱：</span>
        <input v-model="email" type="text" name="" placeholder="邮箱">
      </div>
     <div class="address-border">
        <div class="set-default-css">
          <input type="checkbox" v-model="addDefault">
          <span>设置为默认收货地址</span>
        </div>
      </div>
      <div style="text-align:center;">
        <span @click="saveAddressButton" class="address-button">保存</span>
        <span @click="cancelAddress" class="address-button">取消</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Vue from 'vue';
import {mapActions, mapMutations,mapGetters} from 'vuex';
import {Dialog, Select, Option, MessageBox} from 'element-ui';
import { getProvince, getAddressDetail, getAddressList, doAjaxSetDefAddress, doAjaxRemoveAddress} from "@/assets/request/AddressRequest";
import {PHONE_REGULAR} from '@/http/request';
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
export default {
  name: "EditAddress",
  data:()=>({
    addDefault:true,
    area:0,
    areaList:[],
    city:0,
    cityList:[],
    province:0,
    provinceList:[],
    receivingDetailedAddress:'',
    phone:'',
    consigneeName:'',
    telephone:'',
    email:'',
  }),
  computed:{
    ...mapGetters(['getAddressModal']),
  },
  methods:{
    ...mapMutations(['editGlobalEditAddressShow']),
    ...mapActions(['saveAddress']),
    cancelAddress(){
      this.editGlobalEditAddressShow({show:false,id:null});
    },
    getProvince(){
      this.area=0;
      this.city=0;
      getProvince().then(value => {
        if(Number(value.status)!==200) return alert(value.statusText);
        if(Number(value.data.code)!==200) return alert(value.msg);
        this.provinceList =value.data.data.map(item=>({
          ...item,
          dt_id:Number(item.dt_id),
        }));
      });
    },
    getArea(callback){
      this.area=0;
      getProvince('city',this.city).then(value => {
        if(Number(value.status)!==200) return alert(value.statusText);
        if(Number(value.data.code)!==200) return alert(value.msg);
        this.areaList =value.data.data.map(item=>({
          ...item,
          dt_id:Number(item.dt_id),
        }));
        toString.call(callback)==='[object Function]' && callback();
      });
    },
    getCity(callback){
      this.city=0;
      this.area=0;
      getProvince('province',this.province).then(value => {
        if(Number(value.status)!==200) return alert(value.statusText);
        if(Number(value.data.code)!==200) return alert(value.msg);
        this.cityList = value.data.data.map(item=>({
          ...item,
          dt_id:Number(item.dt_id),
        }));
        toString.call(callback)==='[object Function]' && callback();
      });
    },
    saveAddressButton(){
      const arr = [
          [!Number(this.province),'未选择省'],
          [!Number(this.city),'未选择市'],
          [!Number(this.area),'未选择区'],
          [!String(this.receivingDetailedAddress).trim(),'未选择详细地址'],
          [!String(this.consigneeName).trim(),'收货人姓名不能为空'],
          [!String(this.telephone).trim(),'请输入手机号'],
          [String(this.telephone).length<11,'请输入11位的手机号'],
          [!PHONE_REGULAR.test(this.telephone),'手机号不符合规范'],
      ];
      const find = arr.find(i=>i[0]);
      if(find) return MessageBox.alert(find[1]);
      const emitObject = {
        province:this.province,
        city:this.city,
        county:this.area,
        detailAddress:this.receivingDetailedAddress,
        lxr:this.consigneeName,
        phone:this.phone,
        defaultAddress:Number(this.addDefault),
        id:this.getAddressModal.id,
        //找到下面的参数
        provinceName:this.provinceList.find(i=>i.dt_id===this.province).dt_name,
        cityName:this.cityList.find(i=>i.dt_id===this.city).dt_name,
        telephone:this.telephone,
        email:this.email,
      };
      const id=this.getAddressModal.id;
      id?emitObject['addressId']=id:null;
      this.saveAddress(emitObject);
    },
  },
  created() {
    Object.assign(this.$data,this.$options.data.call(this));
    if(!this.getAddressModal.id) return;
    getAddressDetail(this.getAddressModal.id).then(r=>{
      console.log(r);
      if(r.status!==200) return alert(r.statusText);
      const data = r.data.data;
      this.addDefault=Number(data.is_default);

      this.province= Number(data.provinceid);
      getProvince('province',this.province).then(value => {
        if(Number(value.status)!==200) return alert(value.statusText);
        if(Number(value.data.code)!==200) return alert(value.msg);
        this.cityList = value.data.data.map(item=>({
          ...item,
          dt_id:Number(item.dt_id),
        }));
      });
      this.city=Number(data.cityid);
      getProvince('city',this.city).then(value => {
        if(Number(value.status)!==200) return alert(value.statusText);
        if(Number(value.data.code)!==200) return alert(value.msg);
        this.areaList =value.data.data.map(item=>({
          ...item,
          dt_id:Number(item.dt_id),
        }));
      });
      this.area=Number(data.countyid);
      this.receivingDetailedAddress=data.address;
      this.phone=data.phone;
      this.consigneeName=data.lxr;
      this.telephone=data.telephone;
      this.email=data.email;
    }).catch(r=>{
      alert('获取地址详情异常');
      console.trace({
        message:'获取地址详情异常',
        r
      });
    });
  },
  mounted() {
    // this.areaList=[];
    // this.cityList= ;
    // this.provinceList=[];
    this.getProvince();
  },
}
</script>

<style scoped lang="scss">
.el-select-dropdown__item.selected{
  color: var(--JN_mainColor);
}
.address-button{
    width: 70px;
    background: var(--JN_mainColor);
    color: #fff;
    line-height: 30px;
    border-radius: 3px;
    cursor: pointer;
    margin: 10px auto;
    text-align: center;
    display: inline-block;
  }
.address-border{
  width: 550px;
  margin: 12px auto;
  input {
    width: 428px;
    height: 34px;
    padding: 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius:4px;
    &[type="checkbox"] {
      width: 20px;
      height: 20px;
      padding: 10px;
      font-size: 14px;
      border: 1px solid #ccc;
      border-radius:4px;
      vertical-align: middle;
    }
  }
  select {
    border: 1px solid #ccc;
    height: 34px;
    font-size: 14px;
    width: 140px;
    border-radius:4px;
  }
}
.span-left {
  height: 38px;
  width: 105px;
  line-height: 36px;
  display: inline-block;
  text-align: left;
  position: relative;
  &>i{
    position: absolute;
    top: 0;
    left: -1em;
    color:#f00;
    margin-right: 6px;
  }
}
input{
  transition: all .2s linear 0s;
  &:hover,&:focus{
    border-color: var(--JN_mainColor);
  }
}
</style>